import script from "./UDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UDialog.vue?vue&type=style&index=0&id=7e72f7ea&lang=css"

const __exports__ = script;

export default __exports__